<template>
  <div class="page">
    <nav-bar title="练习情况" :fixed="true" :placeholder="true" left-text="返回" left-arrow @click-left="onClickLeft" />

    <div class="summer">
      <div class="content">
        <div class="sale">{{((info.activeNum-info.errorNum || 0)*100/info.activeNum || 1).toFixed(1)}}<span class="percent">%</span></div>
        <div class="desc">答题正确率</div>

        <div class="data">
          <div class="item">
            <div class="num">{{formatSeconds(info.endTime - info.startTime)}}</div>
            <div class="title">练习时间</div>
          </div>
          <div class="item">
            <div class="num">{{info.errorNum || 0}}</div>
            <div class="title">我的错题</div>
          </div>
          <div class="item">
            <div class="num">{{info.activeNum || 0}}</div>
            <div class="title">已答题数</div>
          </div>
        </div>
      </div>

      <div class="tools">
        <div class="btn info" @click="toRest">重新答题</div>
        <div class="btn plan" @click="toError">查看错题</div>
      </div>

    </div>
  </div>
</template>
<script>
import { NavBar } from "vant";
import { doReset, getLibDetail } from "@api/exam";
import { decrypt } from "@utils/crypto";
import { formatSeconds } from "@utils";

export default {
  components: {
    NavBar,
  },
  data: function() {
    return {
      formatSeconds,
      id : this.$route.params.id,
      info:{},
      answerSheet: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    toError(){
      this.$router.push(`/exam/practice/wrong/view/${this.id}`)
    },
    toRest(){
      doReset(this.id,[]).then(()=> {
        this.$router.replace(`/exam/practice/order/start/${this.id}`)
      })
    },
    init() {
      getLibDetail(this.id).then(res => {
        let data = decrypt(res.result)
        this.info = JSON.parse(data)|| {}
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  background: url("~@images/practice_bg.png") 0 0 #1db0fc no-repeat;
  min-height: 100vh;

  .summer {
    width: 90%;
    margin: 20px auto;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    min-height: 340px;

    .content {
      position: relative;
      top: 40px;

      .name {
        font-size: 18px;
        color: #666;
        text-align: center;

      }

      .sale{
        margin-top:38px;
        color: #fe5859;
        font-size: 46px;
        font-weight: 700;
        text-align: center;
        .percent{
          font-size: 32px;
        }
      }
      .desc{
        color:#666;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin:10px 0;
      }

    }

    .data{
      display: flex;
      padding: 20px 10px;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      margin-top: 30px;

      .item{
        .num{
          font-size: 14px;
          font-weight: 400;
        }
        .title{
          font-size: 14px;
          color: #898989;
          margin: 10px 0;
        }
      }
    }

    .tools{
      margin-top: 35px;
      display: flex;

      .btn{
        margin:10px auto;
        padding: 6px 20px;
        text-align: center;
        background-color: #00aaea;
        color:#fff;
        border-radius: 30px;
        font-size: 12px;

        &.info{
          background-color: #fff;
          color:#00aaea;
          border:1px solid #00aaea;

        }
        &.error{
          color: #fff;
          border:1px solid #fe5859;
          background-color: #fe5859;
        }
      }
    }

  }

}
</style>
